<div class="card {{ paymentprovider().active ? 'active' : 'deactive' }}">
  <div class="card-header">
    <frontend-frontendlib-components-paymentprovider-switcher 
      [isOpen]="!isClosed"
      [paymentprovider]="paymentprovider()"
      [channel]="parameterService.channel"
      (togglePaymentProvider)="doTogglePaymentprovider()"
    />
  </div>
  <div class="paymentoverview collapse {{isClosed ? '' : 'show'}}" #collapsedContent>
    <div class="p-4 paymentoverview">
      @if (parameterService.coupon_input === undefined || parameterService.coupon_input === false) {
        <div>
          <h3>{{ paymentprovider().name }}</h3>
          @if (paymentprovider().hint) {
            <p [innerHtml]="paymentprovider().hint"></p>
          }
          @if (paymentprovider().description) {
            <p [innerHtml]="paymentprovider().description"></p>
          }
        </div>
        <div>
        @if (paymentprovider().id !== 'coupon') { 
          @if (paymentprovider().active) {
            <a role="button" [href]="currentPath()" class="btn btn-outline-primary btn-lg paymentlink">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div>
                Jetzt
                {{ parameterService.getOpenAmount() | currency : 'EUR' : 'symbol' }}
                {{ paymentprovider().type === 2 ? 'per' : 'mit' }}<br />{{paymentprovider().name}}
                bezahlen
              </div>
            </a>
          } 
          @else { 
            @if (paymentprovider().error === 'mindurationerror') {
              <p>Nicht auswählbar, da Zeitraum ({{paymentprovider().min_duration}} Tage vorher) zu kurz.</p>
            }
            @if (paymentprovider().error === 'minamounterror') {
              <p>Nicht auswählbar, da Betrag (min. {{ paymentprovider().min_amount }} EUR) zu gering.</p>
            } 
          } 
        } 
        @else { 
          @if (
            paymentprovider().error === undefined && 
            (parameterService.coupon_input === undefined || parameterService.coupon_input === false)
          ) {
            <a (click)="showCouponInfo()" class="btn btn-outline-primary btn-lg paymentlink">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div>Gutschein / Rabatt einlösen</div>
            </a>
          } 
          @if (paymentprovider().error === 'mindurationerror') {
            <p>Nicht auswählbar, da Zeitraum ({{paymentprovider().min_duration}} Tage vorher) zu kurz.</p>
          }
        }
        </div>
      } 
      @else {
        <app-coupon></app-coupon>
      }
      <br/>
    </div>
  </div>
</div>
